import { Box, Link, Typography } from '@mui/material';
import { useScreenResolution } from '../../utils/utils';
const {
  REACT_APP_FOOTER_LINK1,
  REACT_APP_FOOTER_LINK2,
  REACT_APP_FOOTER_YEAR,
  REACT_APP_FOOTER_LINK1_TEXT,
  REACT_APP_FOOTER_LINK2_TEXT,
} = process.env;

const Footer = ({ isFixed = false }) => {
  const isFixedStyles = {
    position: isFixed ? 'fixed' : '',
    bottom: isFixed ? 0 : '',
    width: isFixed ? '100vw' : '100%',
  };
  const isDesktop = useScreenResolution();

  return (
    <Box
      sx={{
        display: 'flex',
        background: '#2e2e2e',
        color: '#fff',
        paddingY: '10px',
        alignItems: 'center',
        justifyContent: 'space-around',
        flexDirection: isDesktop ? 'row' : 'column',
        ...isFixedStyles,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Link
          color="inherit"
          variant="subtitle1"
          underline="hover"
          href={REACT_APP_FOOTER_LINK1}
          target="_blank"
          rel="noreferrer"
        >
          {REACT_APP_FOOTER_LINK1_TEXT}
        </Link>
      </Box>
      <Typography variant="subtitle2">
        &copy; {REACT_APP_FOOTER_YEAR}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Link
          color="inherit"
          variant="subtitle1"
          underline="hover"
          href={REACT_APP_FOOTER_LINK2}
          target="_blank"
          rel="noreferrer"
        >
          {REACT_APP_FOOTER_LINK2_TEXT}
        </Link>
      </Box>
    </Box>
  );
};

export default Footer;
